// @ts-nocheck

import {
	isMasterDataAdTypesRead,
	isMasterDataCustomersRead,
	isMasterDataGroupsRead,
	isMasterDataInventoryTransactionsRead,
	isMasterDataItemExclusionsRead,
	isMasterDataItemShippingMethodConfigurationRead,
	isMasterDataItemsRead,
	isMasterDataKitsRead,
	isMasterDataParametersRead,
	isMasterDataPresentationQuantityReadEnabled,
	isMasterDataPricingRead,
	isMasterDataPrimaryStoreSkuRead,
	isMasterDataSchedulesRead,
	isMasterDataShipmentsRead,
	isMasterDataShippingMethodsRead,
	isMasterDataSkuExclusionsRead,
	isMasterDataSkusRead,
	isMasterDataStoreOrderListRead,
	isMasterDataStoresRead,
	isMasterDataValidSkuItemCombinationsRead,
	isMasterDataValidStoreSkuCombinationsRead,
	isMasterDataRetailSalesReadEnabled,
	isMasterDataWarehouseReadWrite,
} from 'models/user/selector';
import { OPTION_IDENTIFIERS } from './constants';
import { getColumnInfoByIndentifier } from 'models/tableColumns/selector';

export const getTileOperations = (state) => {
	return _.filter(
		[
			{
				title: 'Ad Types',
				description: 'Create or edit types of Ads',
				buttonText: 'EDIT',
				itemIdentifier: OPTION_IDENTIFIERS.AD_TYPES,
				isEnabled: isMasterDataAdTypesRead(state),
			},
			{
				title: 'Customers',
				description: 'View Customer list',
				buttonText: 'VIEW',
				isEnabled: isMasterDataCustomersRead(state),

				itemIdentifier: OPTION_IDENTIFIERS.CUSTOMERS,
			},
			{
				title: 'Groups',
				description:
					'Create custom groups of Stores, SKUs, or Customers for use in order writing or parameter setting',
				buttonText: 'EDIT',
				itemIdentifier: OPTION_IDENTIFIERS.GROUPS,
				isEnabled: isMasterDataGroupsRead(state),
			},
			{
				title: 'Inventory Transactions',
				description: 'View List of all the inventory transactions',
				buttonText: 'VIEW',
				itemIdentifier: OPTION_IDENTIFIERS.INVENTORY_TRANSACTIONS,
				isEnabled: isMasterDataInventoryTransactionsRead(state),
			},
			{
				title: 'Item Exclusions',
				description: 'View list of invalid Store/Item combinations',
				buttonText: 'VIEW',
				isEnabled: isMasterDataItemExclusionsRead(state),
				itemIdentifier: OPTION_IDENTIFIERS.ITEM_EXCLUSIONS,
			},
			{
				title: 'Item Shipping Method Configuration',
				description: 'View Shipping Method setup by Item',
				buttonText: 'VIEW',
				isEnabled: isMasterDataItemShippingMethodConfigurationRead(state),
				itemIdentifier: OPTION_IDENTIFIERS.ITEM_SHIPPING_METHOD_CONFIGURATION,
			},
			{
				title: 'Items',
				description: 'View Item list',
				buttonText: 'VIEW',
				isEnabled: isMasterDataItemsRead(state),
				itemIdentifier: OPTION_IDENTIFIERS.ITEMS,
			},
			{
				title: 'Kits',
				description: 'View Kit Definition by SKU',
				isEnabled: isMasterDataKitsRead(state),
				buttonText: 'VIEW',
				itemIdentifier: OPTION_IDENTIFIERS.KITS,
			},
			{
				title: 'Parameters',
				description: 'View Parameter list',
				buttonText: 'VIEW',
				isEnabled: isMasterDataParametersRead(state),
				itemIdentifier: OPTION_IDENTIFIERS.PARAMETERS,
			},
			{
				title: 'Pricing',
				description: 'View current and historical SKU costs and retails',
				buttonText: 'VIEW',
				isEnabled: isMasterDataPricingRead(state),
				itemIdentifier: OPTION_IDENTIFIERS.PRICING,
			},
			{
				title: 'SKU Exclusions',
				description: 'View list of invalid Store/SKU combinations',
				buttonText: 'VIEW',
				isEnabled: isMasterDataSkuExclusionsRead(state),
				itemIdentifier: OPTION_IDENTIFIERS.SKU_EXCLUSIONS,
			},
			{
				title: 'Primary Store SKU',
				description: 'View Primary Store SKU',
				buttonText: 'VIEW',
				isEnabled: isMasterDataPrimaryStoreSkuRead(state),
				itemIdentifier: OPTION_IDENTIFIERS.PRIMARY_STORE_SKU,
			},
			{
				title: 'SKUs',
				description: 'View SKU list',
				isEnabled: isMasterDataSkusRead(state),
				buttonText: 'VIEW',
				itemIdentifier: OPTION_IDENTIFIERS.SKUS,
			},
			{
				title: 'Schedules',
				description: 'Add/View store schedules',
				isEnabled: isMasterDataSchedulesRead(state),
				buttonText: 'VIEW',
				itemIdentifier: OPTION_IDENTIFIERS.SCHEDULES,
			},
			{
				title: 'Shipments',
				description: 'View List of Retail Shipments',
				buttonText: 'VIEW',
				isEnabled: isMasterDataShipmentsRead(state),
				itemIdentifier: OPTION_IDENTIFIERS.SHIPMENTS,
			},
			{
				title: 'Shipping Methods',
				description: 'View list of Shipping Methods',
				buttonText: 'VIEW',
				isEnabled: isMasterDataShippingMethodsRead(state),
				itemIdentifier: OPTION_IDENTIFIERS.SHIPPING_METHOD,
			},
			{
				title: 'Store Order List',
				description: 'View Store Order List',
				buttonText: 'VIEW',
				isEnabled: isMasterDataStoreOrderListRead(state),
				itemIdentifier: OPTION_IDENTIFIERS.STORE_ORDERS_LIST,
			},
			{
				title: 'Stores',
				description: 'View Store list',
				buttonText: 'VIEW',
				isEnabled: isMasterDataStoresRead(state),
				itemIdentifier: OPTION_IDENTIFIERS.STORES,
			},
			{
				title: 'Valid SKU/Item Combinations',
				description: 'View valid SKU/Item combinations',
				isEnabled: isMasterDataValidSkuItemCombinationsRead(state),
				buttonText: 'VIEW',
				itemIdentifier: OPTION_IDENTIFIERS.VALID_SKU_COMBINATIONS,
			},
			{
				title: 'Valid Store/SKU Combinations',
				description: 'View master configuration of valid Store/SKU combinations',
				buttonText: 'VIEW',
				isEnabled: isMasterDataValidStoreSkuCombinationsRead(state),
				itemIdentifier: OPTION_IDENTIFIERS.VALID_STORE_COMBINATIONS,
			},
			{
				title: 'Warehouses',
				description: 'View Warehouses list',
				buttonText: 'VIEW',
				isEnabled: isMasterDataWarehouseReadWrite(state),
				itemIdentifier: OPTION_IDENTIFIERS.WAREHOUSES,
			},
			{
				title: 'Presentation Quantity',
				description: 'View Presentation Quantity',
				buttonText: 'VIEW',
				isEnabled: isMasterDataPresentationQuantityReadEnabled(state),
				itemIdentifier: OPTION_IDENTIFIERS.PRESENTATION_QUANTITY,
			},
			{
				title: 'Retail Sales',
				description: 'View Retail Sales',
				buttonText: 'VIEW',
				isEnabled: isMasterDataRetailSalesReadEnabled(state),
				itemIdentifier: OPTION_IDENTIFIERS.RETAIL_SALES,
			},
		],
		(f) => f.isEnabled
	).map((res) => {
		const columnInfo = getColumnInfoByIndentifier(state, '123', res.title);
		return { ...res, title: columnInfo?.AppColumnAliasName || res.title };
	});
};
